export default __webpack_public_path__ + "static/media/pdf 1.c837e241.svg";